document.addEventListener('DOMContentLoaded', function() {
  const collectionCarousel = new Swiper('.collection-carousel', {
    slidesPerView: 4,
    spaceBetween: 20,
    centeredSlides: true,
    centeredSlidesBounds: true,
    centerInsufficientSlides: true,
    rewind: true,
    slidesOffsetBefore: 26,
    slidesOffsetAfter: 26,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3.2,
        spaceBetween: 20
      }
    }
  });
});